(function ($) {
    class RLM_NewsSlider {
        constructor () {
            if (!$('.news-slider-wrapper').length) {
                return;
            }
            
            this.initState();        
            this.initEvents();
        }
    
        initState () {
            this.prevItem = 0;
            this.currentItem = 0;
            this.win = $(window);
            this.wrapper = $('.news-slider-wrapper');
            this.slides = this.wrapper.find('.news-slider-slide');
            this.slidesWrapper = this.wrapper.find('.news-slider-slides');
            this.labels = this.wrapper.find('.news-slider-content-item');
            this.dots = this.wrapper.find('.dot');
            this.count = parseInt(this.wrapper.attr('data-count'), 10);
            this.buttons = this.wrapper.find('.btn-outline');
            this.blankSlide = false;
            this.animationInProgress = false;
            this.swipeEffect = new Hammer(this.wrapper[0]);
        }
    
        initEvents () {
            let self = this;

            this.dots.on('click', function() {
                let index = parseInt($(this).attr('data-index'), 10);
                self.blankSlide = true;
                self.setItem(index);
                let sliderPosition = self.wrapper.offset().top + self.wrapper.outerHeight() - $(window).outerHeight();

                if (self.win.outerWidth() > 768) {
                    $('html, body').animate({
                        scrollTop: sliderPosition
                    }, 500);
                }
            });

            this.swipeEffect.on('swipe', ev => {
                if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 2) && ev.deltaX < -100) {
                    let itemIndex = this.currentItem;
                    itemIndex++;

                    if (itemIndex >= this.slides.length) {
                        itemIndex = 0;
                    }
                    
                    this.dots.eq(itemIndex).trigger('click');
                }
    
                if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 4) && ev.deltaX > 100) {
                    let itemIndex = this.currentItem;
                    itemIndex--;

                    if (itemIndex < 0) {
                        itemIndex = this.slides.length - 1;
                    }
                    
                    this.dots.eq(itemIndex).trigger('click');
                }
            });
        }
    
        setItem (index) {
            if (this.animationInProgress) {
                return;
            }

            this.animationInProgress = true;
            this.prevItem = this.currentItem;
            this.currentItem = index;

            if (this.currentItem >= this.count) {
                this.currentItem = 0;
            }

            this.setActiveSlide();
            this.setActiveText();
            this.setActiveDot();
        }

        nextItem () {
            let nextIndex = this.currentItem;
            nextIndex++;
            this.setItem(nextIndex);
        }

        setActiveSlide () {
            this.slidesWrapper.attr('data-current-slide', this.currentItem);

            setTimeout(() => {
                this.animationInProgress = false;
            }, 1000);
        }

        setActiveText () {
            this.labels.removeClass('is-active');
            this.labels.eq(this.prevItem).addClass('is-hidden');
            this.buttons.attr('data-current-slide', this.currentItem);

            setTimeout(() => {
                this.labels.eq(this.prevItem).removeClass('is-hidden');
                this.labels.eq(this.currentItem).addClass('is-active');
            }, 750);
        }

        setActiveDot () {
            this.dots.removeClass('is-active');
            this.dots.eq(this.currentItem).addClass('is-active');
        }
    }
    
    new RLM_NewsSlider();
})(jQuery);